export {
    PaidSocialProof,
    type PaidSocialProofProps
} from "./src/paid-social-proof";
export { PaidSocialProof as default } from "./src/paid-social-proof";
